<template>
  <scout-form
    :is-modified="!!value"
    :half="half"
    label="会社ID"
  >
    <input
      :value="value"
      class="boss-input"
      type="number"
      :max="Number.MAX_SAFE_INTEGER"
      min="0"
      data-test="text-box"
      @keypress="onlyNumberInRange($event)"
      @input="$emit('input', Number($event.target.value) || null)"
    >
  </scout-form>
</template>

<script>
import ScoutForm from '@/components/atoms/ScoutForm'
import eventValidations from '@/lib/eventValidations'

export default {
  components: {
    ScoutForm
  },
  mixins: [eventValidations],
  props: {
    value: {
      required: true,
      validator: prop => typeof prop === 'number' || prop === null
    },
    half: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    isNullValue () {
      return this.value === null
    }
  }
}
</script>
